// extracted by mini-css-extract-plugin
export var playerWrapper = "VideoPlayer-module--playerWrapper--2MJKC";
export var player = "VideoPlayer-module--player--2ssNs";
export var pauseButton = "VideoPlayer-module--pauseButton--3evt4";
export var playButton = "VideoPlayer-module--playButton--1_RKQ";
export var playIcon = "VideoPlayer-module--playIcon---gBht";
export var pauseIcon = "VideoPlayer-module--pauseIcon--2auhf";